<template>
  <div class="content">
    <card title="设备列表">
      <div class="card_tree box_style">
        <div class="search_box fb">
          <div class="icon"><img class="Img" src="@/assets/hs/icon_搜索.png" alt="" /></div>
          <div class="input" id="searchInput">
            <el-input v-model="filterText" placeholder="请输入内容"></el-input>
          </div>
          <p class="btn_search">搜索</p>
        </div>
        <div class="tree_box" id="cardTree">
          <el-tree class="filter-tree" :data="data" :props="defaultProps" ref="tree"> </el-tree>
        </div>
      </div>
    </card>
    <card title="机组拆解图" styles="margin-top:24px">
      <div class="card_chaijie box_style">
        <div class="view_box"></div>
        <div class="btn_box fb">
          <div class="btn">拆解</div>
          <div class="btn">组装</div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';

export default {
  components: {
    Card,
  },
  data() {
    return {
      filterText: '',
      data: [
        {
          id: 1,
          label: '水轮机',
          children: [
            {
              id: 4,
              label: '引水组件',
              code: '',
              children: [
                {
                  id: 'SLJ001',
                  label: '进水管',
                },
                {
                  id: 'SLJ002',
                  label: '电动阀门',
                },
                {
                  id: 'SLJ003',
                  label: '蜗壳',
                },
              ],
            },
            {
              id: 16,
              label: '导水结构',
              code: '',
              children: [
                {
                  id: 'SLJ004',
                  label: '连杆结构',
                },
                {
                  id: 'SLJ005',
                  label: '导叶臂',
                },
                {
                  id: 'SLJ006',
                  label: '封水壳',
                },
              ],
            },
            {
              id: 17,
              label: '工作部件',
              code: '',
              children: [
                {
                  id: 'SLJ007',
                  label: '转轮',
                },
                {
                  id: 'SLJ008',
                  label: '主轴',
                },
                {
                  id: 'SLJ009',
                  label: '径向止推轴承',
                },
                {
                  id: 'SLJ010',
                  label: '径向轴承',
                },
                {
                  id: 'SLJ011',
                  label: '飞轮',
                },
                {
                  id: 'SLJ012',
                  label: '刹车',
                },
                {
                  id: 'SLJ013',
                  label: '联轴器',
                },
              ],
            },
            {
              id: 18,
              label: '泄水部分',
              code: '',
              children: [
                {
                  id: 'SLJ0014',
                  label: '尾水弯管',
                },
                {
                  id: 'SLJ0015',
                  label: '尾水管',
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: '发电机',
          children: [
            {
              id: 'FDJ001',
              label: '外壳',
            },
            {
              id: 'FDJ002',
              label: '轴',
            },
            {
              id: 'FDJ003',
              label: '前导轴承',
            },
            {
              id: 'FDJ004',
              label: '后导轴承',
            },
            {
              id: 'FDJ005',
              label: '定子',
            },
            {
              id: 'FDJ006',
              label: '转子',
            },
            {
              id: 'FDJ007',
              label: '冷却器',
            },
            {
              id: 'FDJ008',
              label: '励磁器',
            },
          ],
        },
        {
          id: 3,
          label: '监控视频',
          children: [
            {
              id: 7,
              label: '二级 3-1',
            },
            {
              id: 8,
              label: '二级 3-2',
            },
          ],
        },
        {
          id: 13,
          label: '水工建筑',
          children: [
            {
              id: 14,
              label: '二级 3-1',
            },
            {
              id: 15,
              label: '二级 3-2',
            },
          ],
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.card_tree {
  width: 480px;
  height: 312px;
  padding: 10px;
  .tree_box {
    margin-top: 12px;
    height: 250px;
    overflow: auto;
  }
}
.search_box {
  //   width: 460px;
  height: 32px;
  align-items: center;
  background: url('@/assets/hs/bg_搜索.png') no-repeat;
  .icon {
    width: 16px;
    height: 16px;
    margin-left: 16px;
  }
  .input {
    width: 370px;
    height: 32px;
  }
  .btn_search {
    width: 72px;
    height: 32px;
    background: url('@/assets/hs/btn_搜索.png') no-repeat;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    padding-left: 10px;
    box-sizing: border-box;
  }
}
</style>
